module.exports = __webpack_public_path__ + "media/images/icons/map-marker-9c1910ff4cba1e5738f5c6ebc34056aa.png";